<template>
  <div>
    <Header />
    <div class="breadcrumb-area gray-bg">
      <div class="container">
        <div class="breadcrumb-content">
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><a href="#">Checkout</a></li>
            <li class="active">Order received</li>
          </ul>
        </div>
      </div>
    </div>
   <div class="myaccount-area pb-50 pt-50">
        <div class="container">
            <h3 class="page-title">Order confirmation</h3>
            <template v-if="eventOrder.name == null">
            <div class="alert alert-warning m-0" role="alert">
                    <i class="fa fa-info-circle p-2"></i>No order to be displayed. Go to <router-link class="text-primary" :to="{ path: `/account`}">Orders page</router-link> to view your orders
                </div>
            </template>

            <template v-else>
            <div class="row">
							<div class="col-lg-12">	
								<div class="alert alert-success mx-0 rounded" role="alert">
											<i class="fa fa-check-square p-2"></i> Tickets purchased successfully
									</div>
							</div>
                <div class="col-lg-12">	
									<div class="container bg-white">					
										<div class="checkout-wrapper">
												<div id="faq" class="panel-group">
													<div class="accordion" role="tablist">													
														<ul class="list-group list-group-flush">
															<li class="list-group-item">Event Name: <b> <br />{{eventOrder.name}}</b></li>
															<li class="list-group-item">From: <b> <br />{{eventOrder.start_date}} - {{eventOrder.start_time}}</b></li>
															<li class="list-group-item">To: <b> <br />{{eventOrder.end_date}} - {{eventOrder.end_time}}</b></li>
															<li class="list-group-item">Venue: <b>  <br />{{eventOrder.venue}}</b></li>
															<li class="list-group-item">Host: <b> <br />{{eventOrder.vendor.name}}</b></li>
														</ul>
													</div>
												</div>
										</div>
									</div>
                </div>
            </div>

						<div class="bg-white mt-4 p-4">
							<div class="title-wrap mb-4">
									<h4 class="cart-bottom-title section-bg-gary-cart">
										Order items
									</h4>
							</div>

							<div class="table-content table-responsive py-2 pl-4"> 
							<table class="table-bordered" style="width:100%">
									<thead>
											<tr style="height:50px">
												<th>Link</th>
												<th>Name</th>
												<th>Transaction ID</th>
												<th>Payment Method</th>												
												<th>Amount</th>
											
											</tr>
									</thead>
									<tbody>
											<tr v-for="ticket in eventOrder.tickets" :key="ticket.id">
												<td><a target="_blank" :href="host + '/t/' + ticket.ticket_url"><u>TICKET LINK</u></a></td>  

												<td>{{ticket.name}}</td>
												
												<td>{{ticket.transaction_id}}</td>

												<td>{{ticket.payment_method}}</td>

												<td>KSh. {{numberFormat(ticket.amount)}}</td>  
													                                   
											</tr>
									</tbody>
							</table>
							</div>
						</div>

           <div class="row mt-4">
						 <div class="col-lg-6"></div>
							<div class="col-lg-6">
								<div class="bg-white p-4">
										<div class="title-wrap mb-4">
												<h4 class="cart-bottom-title section-bg-gary-cart">
												Billing details
												</h4>
										</div>
										<div class="pl-4">
												<p class="card-text">Name: {{eventOrder.tickets[0].buyer}}</p>
												<p class="card-text">Phone number: {{eventOrder.tickets[0].phone_number}}</p>
												<p class="card-text">Email: {{eventOrder.tickets[0].email}}</p>
										</div>                    
									</div>
							</div>
					 </div>
            </template>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapState, mapGetter, mapActions } from "vuex";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import moment from 'moment';

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },

  computed: {
       ...mapState(["serverUrl","eventOrder"]),   
  },

  mounted() {
      
  },

  data() {
    return {
			host: window.location.origin
    };
  },

  created: function () {
      //
  },

  methods: {
		numberFormat(number) {
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
  },
};
</script>